import '../../../common/dashboard/filters/unapplied/toggleable_unapplied_filter_view.js.coffee'
import '../../../common/dashboard/filters/fixed_string_filter_mixin.js.coffee'
import '../single_filters/fixed_string_filter_view.js.coffee'

Namespace 'CustomerVisualMode.Filters.Unapplied'

class CustomerVisualMode.Filters.Unapplied.UnappliedFixedStringFilterView extends
Common.Dashboard.Filters.ToggleableUnappliedFilterView

  initialize: ({filter}) ->
    super({filter})
    _.extend(@, Common.Dashboard.Filters.FixedStringFilterMixin)

  _displayTitle: ->
    @filter.getName()

  toggleOpenFilter: ->
    @openFixedStringFilterModal()

  modalTitle: ->
    I18n.t 'common.session.filters.fixed_string.modal.title'

  modalSubtitle: ->
    I18n.t 'common.session.filters.fixed_string.modal.subtitle'
